<!--
单页面示例：字段较多、两列布局；
-->
<template>
  <scroll-right-frame class="demo-spage-2">
    <div class="rp-wrapper">
      <div class="rp-header">
        <span class="rp-header-title">{{title}}</span>
      </div>
      <div class="rp-body">
        <div class="rp-form">
          <el-form ref="dataform"  :rules="rules"   :model="formData" label-width="140px"  :size="formSize">
            <div style="width: 90%; float: left;">
               <el-form-item label="id" style="display:none">
                <el-input v-model="oldId"></el-input> {{address}}
              </el-form-item>
              <el-form-item label="lng" style="display:none" >
                <el-input v-model="formData.lng"></el-input> 
              </el-form-item>
              <el-form-item label="lat" style="display:none">
                <el-input v-model="formData.lat"></el-input>
              </el-form-item>
             <el-row v-for="(item,index) in listColumnConfig" v-bind:key="index+'-xdfa'">
                <el-col :span="8" v-for="(item1,index1) in item"  v-bind:key="index1+'-xdfa12'">
                    <el-form-item :prop="item1.dataIndex_"  v-if="item1.type=='text'"  :label="item1.name">
                        <el-input  v-model="formData[item1.dataIndex_]" ></el-input>
                    </el-form-item>
                    <el-form-item  :prop="item1.dataIndex_"  v-if="item1.type=='select'" :label="item1.name">
                        <el-select clearable  v-model="formData[item1.dataIndex_]" placeholder="请选择" @focus="selectData(item1)" >
                           <el-option
                            v-for="(item2,index2) in item1['data'] "
                            :key="index2+'_xsdaf7663'"
                            :label="item2[1]"
                            :value="item2[0]">
                        </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            </div>
            <div style="clear: both;"></div>
             <div style="width: 48%; float: left;">
                <el-form-item label="校外具体地址" prop="outAddress" >
                   <el-input v-model="formData.outAddress" oninput="if(value.length>990)value=value.slice(0,990)"  style="width:calc(100% - 56px); float: left;"></el-input>
                   <el-button type="primary"  @click="search()" class="btn btn-solid"  style="float: right;">搜索</el-button> 
                </el-form-item>
             </div>
             <div style="clear: both;"></div>
             <div style="width: 48%; float: left;">
                <el-form-item >
                   <div id="allmap" style="width: 140%; float: left;height:300px"></div>
                </el-form-item>
             </div>
             <br />
              <br />
             <div style="clear: both;"></div>
            <el-form-item size="large" style="text-align: center;">
                <el-button size="small" type="primary"  @click="add()" class="btn btn-solid"  >确定</el-button> 
                <el-button  size="small"  type="primary"  @click="goback()" class="btn btn-solid"  >返回</el-button> 
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="rp-footer">
      </div>
    </div>
  </scroll-right-frame>
</template>
<script>
  import ScrollRightFrame from '../../../components/scroll-right-frame'
  import util from '../../../libs/util'
  export default {
    name: 'classroom-add',
    components: {ScrollRightFrame},
    data() {
      return {
        formSize: 'small',
         gridconfig:{
           gridId: "classroom_jpcp", 
           actionId: "classroom_jpcp",
           url:'/jpcp/classRoom/'
          },
        formData: {},
        imageUrl: '',
        listColumnConfig:[],
        oldId: '',
        title:'教室添加',
        address:'',
        map:{},
        clickStatus: false,
        rules:{
                 outAddress:[
                   { required: true, 
                      message:'校外具体地址不能为空', 
                      trigger: "blur"
                    },
                ]
        }

      }
    },
    watch: {
      '$route':function(to, from) {
                  
        }
    },
    mounted(){
       this.oldId =this.$route.query.id
        if( this.oldId && this.oldId.length >0){
            this.formData= {};
            this.echo();
        }else{
           this.getMaps();
        } 
         util.ajax.post(this.gridconfig.url+'/abstractGrid',{
               params: {actionId:this.gridconfig.actionId}
            }).then((res) => {
                  if (res.data.meta.errCode == 0) {
                  var data =  res.data.data;
                  var listColumnConfig = data.listColumnConfig;
                  const _that = this;
                  var reu = this.arrTrans(2,listColumnConfig,function(item){
                      if(item.dataIndex =='outAddress'){
                        return;
                      }
                      if(item.type =='text' || item.type =='select'){
                          if(item.add){
                            var rule = [];
                            if(item.type =='text'){
                              if(! item.allowBlank){ 
                                rule.push({required: true,  message: item.name+"必填",  trigger: 'blur'});
                              }
                              if(item.checkRegular !=''){ 
                                 rule.push({validator:_that.checkRegular,
                                    reg:item.checkRegular,
                                     regtext:item.checkMessage, 
                                     trigger: ['blur','change']});
                              }
                            }
                            if(item.type =='select'){
                              if(!item.allowBlank){
                                rule.push({required: true,  message: item.name+"必填",  trigger: ["blur",'change'] });
                              }
                            }
                            if(item.maxLength >0){
                                  rule.push({ max:item.maxLength, message: '长度在不能超过'+item.maxLength+'个字符' });
                              }
                            _that.rules[item.dataIndex_] = rule;
                              return item;
                          }
                      }
                  });
                  this.listColumnConfig = reu;
                  }
                }).catch((e) => {
                });        
    },
    methods: {
      checkRegular:(rule, value, callback) => {
            if(value){
             var  str ="/"+rule.reg+"/";
              var  reg = eval(str);
              if(!reg.test(value)){
                       return callback(new Error(rule.regtext));
              }
            }
             callback();
        },replaceColumName(columName){
         return columName.replace(/\.name$/g,".id");
       },
       selectData:function(item){ 
         console.error(item)
         util.ajax.post(this.gridconfig.url+'/selectData',{
                      params:{
                      gridId: this.gridconfig.gridId, 
                      actionId: this.gridconfig.actionId, 
                      columnDataIndex:item.dataIndex}
                    }).then((res) => {
                          if (res.data.meta.errCode == 0) {
                          var data =  res.data.data;
                          item["data"]=data;
                           this.$forceUpdate();
                          }
                        }).catch((e) => {
                        
                        });
       },
       arrTrans(num, arr,func) { // 一维数组转换为二维数组
          const iconsArr = [];
          const hArr=[];
          arr.forEach((item, index)=>{
             if(func){
                var r = func(item);
                if(r){
                  hArr.push(r);
                }
             }
          });
          hArr.forEach((item, index) => {
            const page = Math.floor(index / num); // 计算该元素为第几个素组内
            if (!iconsArr[page]) { // 判断是否存在
              iconsArr[page] = [];
            }
            iconsArr[page].push(item);
          });
          return iconsArr;
        },
      search(){
        var MMview= this;
        var gc = new BMap.Geocoder();
        var address = new Array();
        var local = new BMap.LocalSearch(this.map,{renderOptions:{map: this.map,panel: "results"},onSearchComplete: function(results){ 
          //可以得到搜索结果且搜索结果不为空 
            if(local.getStatus() == BMAP_STATUS_SUCCESS){
              //遍历结果第一页的点
              address = []
              for (var i = 0; i < results.getCurrentNumPois(); i++){
                var poi = results.getPoi(i);
                //下面根据LocalResultPoi对象的值拼html代码，此处略
                if(poi.address){
                  address[i] = poi.address;
                }else{
                  address[i] = "";
                }
              } 
            }
          }
        });  
        local.setMarkersSetCallback(function(pois){
          for(var i=0;i<pois.length;i++){
                //markerArr[i]=pois[i].marker;
                const maker =  pois[i].marker;
                pois[i].marker.addDetail = address[i];
                pois[i].marker.addEventListener("click", function(e){
                  MMview.formData.lng = e.point.lng;
                  MMview.formData.lat = e.point.lat;
                  if(e.currentTarget.addDetail){
                    console.info(e.currentTarget.addDetail)
                    MMview.formData.outAddress = e.currentTarget.addDetail
                    MMview.address = MMview.formData.outAddress;
                  } else {
                    gc.getLocation(e.point,function(rs) {
                      var address =rs.addressComponents;
                      MMview.formData.outAddress=address.province+address.city+address.district+address.street+address.streetNumber;
                      MMview.address=MMview.formData.outAddress;
                    });
                  }
                  MMview.clickStatus = true;
                }) 
          }
        })    
        local.search(this.formData.outAddress);
      },
      getMaps(){
              var lng =  this.formData.lng;
              var lat = this.formData.lat;
              if(lng == '' || lng == null){
                lng = '116.316833';
              }
              if(lat == '' || lat == null){
                lat = '39.998877';
              }
            var MMview= this;
            var map = new BMap.Map("allmap",{minZoom:3,maxZoom:19});   
            this.map =map;
              var gc = new BMap.Geocoder();
              map.centerAndZoom(new BMap.Point(lng, lat), 16);
              map.addControl(new BMap.MapTypeControl({
                mapTypes:[
                        BMAP_NORMAL_MAP,
                        BMAP_HYBRID_MAP
                    ]}));	  
              map.setCurrentCity("北京");         
              map.enableScrollWheelZoom();     
              map.addControl(new BMap.NavigationControl());     
              var point = new BMap.Point(lng, lat);
              var marker = new BMap.Marker(point);  
              marker.content="c_content";
              map.addOverlay(marker);
              ///marker.enableDragging();
              marker.addEventListener("click",function(e) {
                   MMview.formData.lng = e.point.lng;
                   MMview.formData.lat = e.point.lat;
                    gc.getLocation(e.point,
                      function(rs) {

                        var address =rs.addressComponents;
                        MMview.formData.outAddress=address.province+address.city+address.district+address.street+address.streetNumber;
                        MMview.address=MMview.formData.outAddress;
                        MMview.$forceUpdate()
                      });
                 });
              map.addEventListener("click",function(e){
                if(!MMview.clickStatus){
                  MMview.formData.lng = e.point.lng;
                  MMview.formData.lat = e.point.lat;
                  var point = new BMap.Point(e.point.lng, e.point.lat);
                  var marker = new BMap.Marker(point);
                  var allOverlay = map.getOverlays();
                    for (var i = 0; i < allOverlay.length; i++){
                      console.info(allOverlay[i]);
                      if(allOverlay[i].content=='c_content'){
                        map.removeOverlay(allOverlay[i]);
                      }
                    }
                    marker.content="c_content";
                    map.addOverlay(marker); 
                    //marker.enableDragging();
                    marker.addEventListener("click",function(e) {
                    MMview.formData.lng = e.point.lng;
                    MMview.formData.lat = e.point.lat;
                      gc.getLocation(e.point,
                        function(rs) {
                          var address =rs.addressComponents;
                          MMview.formData.outAddress=address.province+address.city+address.district+address.street+address.streetNumber;
                          MMview.address=MMview.formData.outAddress;
                            MMview.$forceUpdate()
                        });
                   });  
                    marker.addEventListener("dragend",function(e) {
                    MMview.formData.lng = e.point.lng;
                    MMview.formData.lat = e.point.lat;
                      gc.getLocation(e.point,
                        function(rs) {
                          var address =rs.addressComponents;
                          MMview.formData.outAddress=address.province+address.city+address.district+address.street+address.streetNumber;
                          MMview.address=MMview.formData.outAddress;
                            MMview.$forceUpdate()
                        });
                   });
                  gc.getLocation(e.point,
                    function(rs) {
                      var address =rs.addressComponents;
                      MMview.formData.outAddress=address.province+address.city+address.district+address.street+address.streetNumber;
                      MMview.address=MMview.formData.outAddress; 
                        MMview.$forceUpdate()
                    });
                  }else{
                    MMview.clickStatus = false;
                  }
              });
        },
      echo(){


      },
      goback(){
            util.routerBack(this,"/");
      },
      add(){
        /*
        if(this.formData.name==null || this.formData.name.trim().length==0){
            this.$notify.error({title: '提示', message: '请输入中心名称'});
            return;
          }
        if( this.formData.telephone&&  this.formData.telephone.trim().length >0){
            this.formData.telephone = this.formData.telephone.trim();
            if(!/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(this.formData.telephone)){
                 this.$notify.error({title: '提示', message: '固定电话有误，请重填'});
                return ;
            }
        }

        if(!this.formData.lng){
            this.$notify.error({title: '提示', message: '请选择地图'});
            return;
        }
        if(this.formData.outAddress.trim().length ==0){
             this.$notify.error({title: '提示', message: '所在地址不能为空'});
            return;
          }
          if(this.formData.outAddress.length>20){
            this.$notify.error({title: '提示', message: '所在地址的长度不能超过20个字符'});
            return;
          }

         var  url ="";
         if(this.formData["id"] >0){
              url = "/blwm/community/abstractUpdate";
        }else{
             url  = "/blwm/community/abstractAdd";
        }
  */
        var  url  = this.gridconfig.url+"/abstractAdd";
        var _formData =this.formData;
        const result =[true];
        this.$refs["dataform"].validate((valid) => {
                    if (!valid) {
                       result[0] =false;
                        return false;
                    }
                });
        if(!result[0]){
              return;
        }   
        for(var obj in _formData){
           if(obj.indexOf("_") > 0){
               var value =_formData[obj];
               var name1 = obj.split("_")[0];
               var name2 = obj.split("_")[0];
              delete _formData[obj];
              _formData[name1]={id : value};
           }
        }
        util.ajax.post(url,{"bean":_formData,params:{}}).then((res) => {
          if (res.data.meta.errCode == 0) {
           var meta = res.data.meta;
            this.$notify.success({title: '提示', message: '操作成功'});
            this.goback();
          }else{
            this.$notify.error({title: '提示', message: res.data.meta.errMsg});
          }
        }).catch((e) => {
          this.showFinishBtn = true
          console.error(e)
        })
      }
    }
  }
</script>
<style lang="scss">
  .demo-spage-2 {
    .el-scrollbar__bar {
      bottom: 16px;
    }
    .rp-wrapper {
      min-width: 1000px;
    }
    .rp-form {
      width: 80%;
      margin-bottom: 30px;
    }
    .avatar-uploader .el-upload {
      border: 2px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    .btn-hollow {
      margin-left: 10px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/custom/components/jpcp/classRoom-add.vue